import React from "react";
import { Box, ButtonBase, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import smFlower from "../../../assets/icons/SM_long_flower_white.png";
import smFlower2 from "../../../assets/icons/SM_short_flower_white.png";

const PATTERNS = [
    { image: smFlower2, opacity: 0.2, transform: "translateY(40%)" },
    { image: smFlower, opacity: 0.2, transform: "rotate(90deg) translateY(10%)" },
    { image: smFlower2, opacity: 0.2, transform: "translateY(30%)" },
];

export default function ProductsDropdownMenu({ items = [], onNavigate }) {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 1, py: 1 }}>
            {items.map((item, index) => {
                const pattern = PATTERNS[index % PATTERNS.length];

                // ✅ per-item left image controls with sane defaults
                const leftCfg = item.leftImage || {};
                const leftW = leftCfg.width ?? 120;
                const leftH = leftCfg.height ?? 100;
                const leftTransform = leftCfg.transform ?? "translate(-5%, 30%)";
                const leftFit = leftCfg.objectFit ?? "cover";
                const leftPos = leftCfg.objectPosition ?? "center";

                // ✅ optional per-item right image controls (if you add them later)
                const rightCfg = item.rightImage || {};
                const rightW = rightCfg.width ?? 90;
                const rightH = rightCfg.height ?? 90;
                const rightTransform = rightCfg.transform ?? "translateY(10%)";
                const rightFit = rightCfg.objectFit ?? "cover";
                const rightPos = rightCfg.objectPosition ?? "left";

                return (
                    <ButtonBase
                        key={item.id}
                        component={RouterLink}
                        to={item.to}
                        onClick={onNavigate}
                        sx={{
                            display: "inline-flex",
                            width: "auto",
                            borderRadius: 5,
                            overflow: "visible",
                            textAlign: "left",
                            alignSelf: "flex-start",
                            transition: "transform 180ms cubic-bezier(.2,.8,.2,1)",
                            "&:hover": { transform: "translateY(-2px) scale(1.02)" },
                            "&:hover .pill": { boxShadow: "0 14px 32px rgba(0,0,0,0.22)", filter: "saturate(1.05)" },
                            "&:hover .fg": { transform: "translateY(-1px)" },
                            "&:focus-visible .pill": { outline: "2px solid rgba(255,255,255,0.85)", outlineOffset: 2 },
                        }}
                    >
                        <Box
                            className="pill"
                            sx={{
                                position: "relative",
                                height: 64,
                                display: "inline-flex",
                                alignItems: "center",
                                pr: item.rightImageSrc ? 0 : 2,
                                background: item.bg || "rgba(123,64,36,0.10)",
                                borderRadius: 5,
                                overflow: "hidden",
                                transition: "box-shadow 220ms cubic-bezier(.2,.8,.2,1), filter 220ms cubic-bezier(.2,.8,.2,1)",
                            }}
                        >
                            {/* Pattern layer */}
                            <Box
                                component="img"
                                src={pattern.image}
                                alt=""
                                sx={{
                                    position: "absolute",
                                    width: "100%",
                                    height: "500%",
                                    objectFit: "cover",
                                    transform: pattern.transform || "none",
                                    opacity: pattern.opacity,
                                    zIndex: 1,
                                    pointerEvents: "none",
                                }}
                            />

                            {/* Foreground */}
                            <Box
                                className="fg"
                                sx={{
                                    position: "relative",
                                    zIndex: 2,
                                    display: "inline-flex",
                                    alignItems: "center",
                                    transition: "transform 220ms cubic-bezier(.2,.8,.2,1)",
                                }}
                            >
                                {/* LEFT product image (per-item configurable) */}
                                <Box
                                    component="img"
                                    src={item.imageSrc}
                                    alt=""
                                    sx={{
                                        height: leftH,
                                        width: leftW,
                                        objectFit: leftFit,
                                        objectPosition: leftPos,
                                        flex: "0 0 auto",
                                        transform: leftTransform,
                                    }}
                                />

                                <Typography
                                    sx={{
                                        fontWeight: 900,
                                        textTransform: "uppercase",
                                        letterSpacing: "0.04em",
                                        fontSize: 20,
                                        color: "#fff",
                                        lineHeight: 1,
                                    }}
                                >
                                    {item.label}
                                </Typography>

                                {/* RIGHT image if present (also configurable if you add rightImage config) */}
                                {item.rightImageSrc && (
                                    <Box
                                        component="img"
                                        src={item.rightImageSrc}
                                        alt=""
                                        sx={{
                                            height: rightH,
                                            width: rightW,
                                            objectFit: rightFit,
                                            objectPosition: rightPos,
                                            flex: "0 0 auto",
                                            transform: rightTransform,
                                        }}
                                    />
                                )}
                            </Box>
                        </Box>
                    </ButtonBase>
                );
            })}
        </Box>
    );
}
